export default __webpack_public_path__ + "static/media/andrey.53d0285e.jp2";